import { Injectable } from '@angular/core';

import { distributionFooterBlockType } from '../../../../../Common/TargetingShared/model/distribution-block-types.model';
import { FooterDisplayElementModel } from '../../../../../Common/TargetingShared/model/footer-display-element.model';
import { PlainTextService } from '../../../../../Common/PageBuilder/services/plain-text.service';

import { DistributionBlockTypeEnum } from '../../../enums/distribution-block-type.enum';
import { BlockModel } from '../../../../../Common/PageBuilder/models/block.model';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { LayoutBlock } from '../../../../../Common/PageBuilder/models/layout-block.model';


@Injectable()
export class DistributionPlainTextService extends PlainTextService {

    constructor(protected localizationService: LocalizationService) {
        super(localizationService);
    }

    generateBodyPlainText(blocks: BlockModel[]): string {
        const bodyBlocks = blocks.filter(x => x.type.key !== DistributionBlockTypeEnum.footer);
        let bodyText = '';
        bodyBlocks.forEach(block => {
            const newBlockText = this.generateBlockPlainText(block);
            if (newBlockText) {
                bodyText += newBlockText + '\n';
            }
        });

        return bodyText;
    }

    generateBlockPlainText(block: BlockModel): string {
        let newBlockText = '';
        switch (block.type.key) {
            case DistributionBlockTypeEnum.title:
                newBlockText = this.generatePlainTextFromTitleBlock(block);
                break;
            case DistributionBlockTypeEnum.text:
                newBlockText = this.generatePlainTextFromTextBlock(block);
                break;
            case DistributionBlockTypeEnum.image:
                newBlockText = this.generatePlainTextFromImageBlock(block);
                break;
            case DistributionBlockTypeEnum.divider:
                newBlockText = '\n';
                break;
            case DistributionBlockTypeEnum.button:
                newBlockText = this.generatePlainTextFromButtonBlock(block);
                break;
            case DistributionBlockTypeEnum.oneColumnLayout:
            case DistributionBlockTypeEnum.twoColumnLayout:
            case DistributionBlockTypeEnum.threeColumnLayout:
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        newBlockText += this.generateBlockPlainText(x);
                    });
                    newBlockText += '\n';
                });
        }

        return newBlockText;

    }

    generateFooterPlainText(blocks: BlockModel[]): string {
        const footerDisplayElement = blocks.find(block => block.type.key === distributionFooterBlockType.key)?.
            displayElement.clone() as FooterDisplayElementModel;

        if (footerDisplayElement) {
            footerDisplayElement.updateRenderedText(true);
            return this.parseHTML(footerDisplayElement.renderedText);
        }

        return '';
    }
}
